import PropTypes from 'prop-types';

export function DropDownAction(props) {
  const { app, em, data } = props;

  if (!em?.id) console.warn('DropDownAction must have ID')

  let mainButtonClass = ` btn-` + (em?.color || 'light');
  if (em?.size) mainButtonClass += ` btn-${em.size}`;

  let subButtonClass = ``;
  if (em?.size) subButtonClass += ` btn-${em.size}`;

  return (
    <div className="dropdown">
      <button
        className={`btn ${mainButtonClass} dropdown-toggle`}
        type="button"
        id={em?.id}
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {em?.label || 'Action'}
      </button>
      <div className="dropdown-menu" aria-labelledby={em?.id}>
      {em.buttons &&
        em.buttons.map((t, i) => {
          if (t.type && t.type === 'hr') {
            return <hr key={(em?.id || 'dda') + `-${i}`} />;
          }

          let _show = true;

          if (typeof t.showBy !== 'undefined') {
            const criteria = t.showBy.split(':');
            const _fld = criteria[0];
        
            if (data[_fld]) {
              if (criteria.length > 1 && typeof data[_fld]==='string') {
                _show = (data[_fld].trim()!=='' 
                  && data[_fld].match(new RegExp(criteria[1], 'i'))) ? true : false;
              } else {
                _show = (data[_fld]===true || `${data[_fld]}`.match(/1|A|Y/i)) ? true : false;
              }
            } else {
              _show = false;
            }
            
            if (criteria.length > 1 && criteria[1].match(/null|empty|false/i)) {
              _show = !data[_fld] || `${data[_fld]}`.trim()==='';
            }
          }

          if (!_show) return null;

          return <button type="button" key={(em?.id || 'dda') + `-${i}`}
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault();
            app && app.handlers && t.click && app.handlers[t.click] && app.handlers[t.click](data);
          }}          
          className={`dropdown-item ${subButtonClass}`}>
            {t.label}
          </button>
        })
      }
      </div>
    </div>
  );
}

DropDownAction.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any, 
  data : PropTypes.any, 
}